import React from "react";
import Table from "react-bootstrap/Table";
import "../../../_static/instrument.css"
import InstrumentSelectorBTK from "./InstrumentSelectorBTK";
import UnpackButton from "../../../../buttons/UnpackButton";
import DeleteButton from "../../../../buttons/DeleteButton";
import SelectInput from "../../../formElements/SelectInput";

function InstrumentBTKTable(props) {
    function selectInstrument(event, index) {
        props.selectInstrument(event, index)
    }

    return (
        <div>
            <Table responsive striped hover className="InstrumentTable outer-bordered">
                <tbody>
                <tr>
                    <td className="narrow">
                        {props.unpackable===true && <UnpackButton onClick={props.unpackSection}/>}
                    </td>
                    <td className="narrow">
                        <DeleteButton height="30" width="30"
                                      onClick={() => props.deleteInstrument(props.instrumentIndex)}/>
                    </td>
                    <td>{!props.empty && props.instrument.Pristroj.Produkt.Typ}</td>
                    <td className="narrow">SN:</td>
                    <td>
                        <InstrumentSelectorBTK value={!props.empty ? props.instrument.Pristroj : ""}
                                               selectInstrument={props.selectInstrument}
                                               instrumentIndex = {props.instrumentIndex}
                                               data={props.data}
                                               optionDisplay="SNR"
                                               ndx={props.ndx}
                                               index={null}
                                               stateResetOnChange={true}
                                               empty={props.empty}
                        />
                    </td>
                    <td>{!props.empty && props.instrument.Pristroj.Produkt.Nazov}</td>
                    <td className="narrow">Demo:</td>
                    <td>{!props.empty && props.instrument.Pristroj.Demo ? 'Áno' : 'Nie'}</td>
                    <td className="narrow">Výsledok:</td>
                    <td>
                        <SelectInput options={['', ...props.data.Vysledok_Kontroly_options.map(option => option.Vysledok)]}
                                     name={'Vysledok_Kontroly'}
                                     value={props.data.Pristroje[props.instrumentIndex].Vysledok_Kontroly}
                                     onChange={event => props.selectBTKResult(event, props.instrumentIndex)}
                                     skipMb={true}
                        />
                    </td>
                </tr>
                </tbody>
            </Table>
        </div>
    )
}

export default InstrumentBTKTable
